import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const PersonalInfoSharingListDesktop = loadable(() => import("./PersonalInfoSharingList"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <PersonalInfoSharingListDesktop {...props} />
  </ErrorBoundary>
);
